import messages from './exchange-results-lang.json';
import { DISPLAY_DATE_FORMAT, DISPLAY_TIME_FORMAT } from '../../../common/js/constants/constants';
export default {
	data() {
		return {
			displayDateFormats: DISPLAY_DATE_FORMAT,
			displayTimeFormats: DISPLAY_TIME_FORMAT
		};
	},
	props: ['results'],
	i18n: { messages },
	computed: {
		displayDateFormat() {
			return this.displayDateFormats[this.$i18n.locale];
		},
		displayTimeFormat() {
			return this.displayTimeFormats[this.$i18n.locale];
		}
	}
};
